import { render, staticRenderFns } from "./AlarmConfiguration.vue?vue&type=template&id=3f52e840&scoped=true"
import script from "./AlarmConfiguration.vue?vue&type=script&lang=js"
export * from "./AlarmConfiguration.vue?vue&type=script&lang=js"
import style0 from "./AlarmConfiguration.vue?vue&type=style&index=0&id=3f52e840&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f52e840",
  null
  
)

export default component.exports